import Page from "../../components/Page";

export default function Membership() {
  return (
    <Page title="Earthsave Membership">
      <p>
        <b> Earthsave Members </b>take pride in supporting an organization that
        is influencing opinions and educating thousands about the compelling
        environmental, health, and humane reasons for adopting a plant based
        diet.
      </p>
      <br />
      <p>
        <b>Benefits of Membership:</b>
      </p>
      <br />
      <p>- Discounted fees at most Earthsave Baltimore events</p>
      <p>- Members may display literature and make announcements at dinners</p>
      <p>- Free half-hour session with registered dietitian Mark Rifkin</p>
      <br />
      <p>
        <b>Donations</b> are <b>tax deductible,</b> but basic membership fees
        are not. Basic fees are <b>$35</b> for Individual, or <b>$50</b> for
        Family Membership, <b>$40</b> for Senior Couple, or <b>$25</b> for
        Student or Senior. Please make your check or money order payable to
        Earthsave and send to 517 Talbott Ave. Lutherville MD, 21093. Any amount
        beyond the basic fee is tax deductible. Thanks for your kind support!
      </p>
      <br />
      <p>
        {" "}
        For further information, call 410-252-3043 or email
        baltimore@earthsave.org. Hope to see you soon!
      </p>
    </Page>
  );
}


